import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { validateRedirectUrl } from '@/lib/utils';
import { SocialAuthButtons } from '@/components/auth/SocialAuthButtons';
import { AuthCloseButton } from '@/components/auth/AuthCloseButton';

export function SignUpView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, user, isLoading: authLoading } = useAuth();

  // Get and validate redirect parameter from URL
  const searchParams = new URLSearchParams(location.search);
  const rawRedirectPath = searchParams.get('redirect');
  const redirectPath = validateRedirectUrl(rawRedirectPath);

  // Redirect to home if already signed in with a real account.
  useEffect(() => {
    if (!authLoading && session && user && !user.is_anonymous) {
      navigate('/', { replace: true });
    }
  }, [session, user, authLoading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-telekinesis-bg-dark p-4">
      <AuthCloseButton />
      <div className="w-full max-w-md">
        <div className="rounded-lg bg-telekinesis-bg-secondary-dark p-8 shadow-md">
          <div className="mb-4 flex flex-col items-center justify-center gap-2">
            <h1 className="text-xl font-semibold text-white">Create Account</h1>
          </div>
          <div className="w-full py-2">
            <SocialAuthButtons redirectPath={redirectPath} />
          </div>
          <div className="pt-4 text-center text-sm text-telekinesis-text-secondary">
            <Link
              to="/signup-email"
              className="text-telekinesis-text-primary hover:underline"
            >
              Sign up with email
            </Link>
            {' or '}
            <Link to="/signin" className="text-[#107d40] hover:underline">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
